import * as React from 'react'
import { icons } from './icons'
import styled from 'styled-components'
import { lighten } from 'polished'
// @ts-ignore
import * as theme from 'styled-theming'

interface Props extends React.SVGAttributes<SVGElement> {
  icon: string
  size?: number
}

export const Icon: React.SFC<Props> = ({ icon, size = 30, ...props }) => (
  <Wrapper
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={size}
    height={size}
    {...props}
  >
    <path d={icons[icon]} />
  </Wrapper>
)

const colors = {
  icon: theme('mode', {
    light: (props: any) => lighten(0.25, props.theme.color.black),
    dark: (props: any) => lighten(0.5, props.theme.color.black),
  }),
}

const Wrapper = styled.svg`
  fill: ${colors.icon};
`



// WEBPACK FOOTER //
// ./src/components/Icon/index.tsx